/**
 * Task Status Types
 *
 * Mirrors the status values exposed by `backend/services/task_status.py` and Celery results.
 * Keep this file in sync with backend enums and update documentation when new states appear.
 */

export const taskStatuses = [
  'PENDING',
  'STARTED',
  'RETRY',
  'SUCCESS',
  'FAILURE',
  'CANCELED',
] as const;

export type TaskStatus = (typeof taskStatuses)[number];

export type TaskStatusCategory =
  | 'queued'
  | 'processing'
  | 'retrying'
  | 'success'
  | 'failure'
  | 'canceled';

export const terminalTaskStatuses: TaskStatus[] = [
  'SUCCESS',
  'FAILURE',
  'CANCELED',
];

export const taskStatusCategoryMap: Record<TaskStatus, TaskStatusCategory> = {
  PENDING: 'queued',
  STARTED: 'processing',
  RETRY: 'retrying',
  SUCCESS: 'success',
  FAILURE: 'failure',
  CANCELED: 'canceled',
};

export function isTaskStatus(value: string): value is TaskStatus {
  return (taskStatuses as readonly string[]).includes(value);
}
